import { Extension } from '@tiptap/core'

export interface KeyboardOptions {
  handler: (type: string) => boolean
}

/** Extension for capturing (keyboard) events and providing them to the outside. */
export const Keyboard = Extension.create<KeyboardOptions>({
  name: 'keyboard-shortcuts',

  addOptions() {
    return {
      handler: (_) => {}
    } as KeyboardOptions
  },

  addKeyboardShortcuts() {
    return {
      'Mod-k': () => this.options.handler("link"),
    }
  },
})

export default Keyboard
